module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promotion-qt"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "top pc-show"
  }, [_c('div', {
    staticClass: "top-content"
  }, [_c('div', [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/email.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('top_email')))])]), _vm._v(" "), _c('div', {
    staticClass: "telegram"
  }, [_c('img', {
    staticClass: "telegram",
    attrs: {
      "src": require("../../../../static/img/promotion/telegram.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('top_telegram')))])])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/faq.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "Https://t.me/joinchat/EHER6Q0FAGp1rNLajkldPA"
    }
  }, [_vm._v(_vm._s(_vm.$tc('top_faq', 1)))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/faq"
    }
  }, [_vm._v(_vm._s(_vm.$tc('top_faq', 2)))])], 1)])]), _vm._v(" "), _c('plex-header', {
    staticClass: "pc-show",
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-top"
  }, [_c('plex-header', {
    staticClass: "phone-show",
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "phone-show",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../../static/img/promotion/app.png"),
      "alt": "qt"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right-top"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('features')))]), _vm._v(" "), _c('span'), _vm._v(" "), _c('div', [_c('div', [_c('img', {
    staticClass: "features_mark",
    attrs: {
      "src": require("../../../../static/img/promotion/features_mark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('features_con1')))])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "features_mark",
    attrs: {
      "src": require("../../../../static/img/promotion/features_mark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('features_con2')))])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "features_mark",
    attrs: {
      "src": require("../../../../static/img/promotion/features_mark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('features_con3')))])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "features_mark",
    attrs: {
      "src": require("../../../../static/img/promotion/features_mark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('features_con4')))])]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "features_mark",
    attrs: {
      "src": require("../../../../static/img/promotion/features_mark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('features_con5')))])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('features_btn')))]), _vm._v(" "), _c('img', {
    staticClass: "seven-days",
    attrs: {
      "src": require("../../../../static/img/promotion/7-days.png"),
      "alt": "7-days"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "platform pc-show"
  }, [_c('p', [_c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=windows",
      "aria-label": "windows"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-windows"
    }
  })])]), _vm._v("Windows")]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=mac",
      "aria-label": "mac"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-Macos"
    }
  })])]), _vm._v("Mac")]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=ios",
      "aria-label": "ios"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-pingguo"
    }
  })])]), _vm._v("iOS")]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=android",
      "aria-label": "android"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-anzhuo"
    }
  })])]), _vm._v("Android")]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=ubuntu",
      "aria-label": "ubuntu"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-Ubuntu"
    }
  })])]), _vm._v("Ubuntu")]), _vm._v(" "), _c('router-link', {
    staticClass: "download-link",
    attrs: {
      "to": "/download?platform=androidTV",
      "aria-label": "android_tv"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-androidTV"
    }
  })])]), _vm._v("Android TV")])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "simple-steps pc-show"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('steps')))]), _vm._v(" "), _c('span'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "steps-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('steps_num1')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('steps_num2')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('steps_num3')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('steps_btn')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "simple-steps phone-show"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('steps')))]), _vm._v(" "), _c('span'), _vm._v(" "), _c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "steps-text"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/steps_app1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('steps_num1')))])]), _vm._v(" "), _c('div', {
    staticClass: "steps-text"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/steps_app2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('steps_num2')))])]), _vm._v(" "), _c('div', {
    staticClass: "steps-text"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/steps_app3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('steps_num3')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('steps_btn')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "features"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('main_features')))]), _vm._v(" "), _c('span'), _vm._v(" "), _c('div', {
    staticClass: "ftu-text1"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/ftu_01.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('main_features_title1')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('main_features_con1')))])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/ftu_02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('main_features_title2')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('main_features_con2')))])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/ftu_03.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('main_features_title3')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('main_features_con3')))])])]), _vm._v(" "), _c('div', {
    staticClass: "ftu-text2"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/ftu_04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('main_features_title4')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('main_features_con4')))])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/ftu_05.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('main_features_title5')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('main_features_con5')))])]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/ftu_06.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('main_features_title6')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('main_features_con6')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "reviews"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('reviews')))]), _vm._v(" "), _c('span'), _vm._v(" "), _c('div', {
    staticClass: "carousel"
  }, [_c('review-text')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "faqs"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('faqs')))]), _vm._v(" "), _c('span'), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('faqs_title1')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('faqs_con1')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('faqs_title2')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('faqs_con2')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('faqs_title3')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('faqs_con3')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('steps_btn')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('footer')))]), _vm._v(" "), _c('img', {
    staticClass: "left-mark",
    attrs: {
      "src": require("../../../../static/img/promotion/left_mark.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "right-mark",
    attrs: {
      "src": require("../../../../static/img/promotion/right_mark.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top phone-show"
  }, [_c('div', {
    staticClass: "top-content"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/email.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('top_email')))])]), _vm._v(" "), _c('div', {
    staticClass: "telegram"
  }, [_c('img', {
    staticClass: "telegram",
    attrs: {
      "src": require("../../../../static/img/promotion/telegram.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('top_telegram')))])]), _vm._v(" "), _c('div', {
    staticClass: "faq"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/faq.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "Https://t.me/joinchat/EHER6Q0FAGp1rNLajkldPA"
    }
  }, [_vm._v(_vm._s(_vm.$tc('top_faq', 1)))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/faq"
    }
  }, [_vm._v(_vm._s(_vm.$tc('top_faq', 2)))])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-images"
  }, [_c('img', {
    staticClass: "bg-top pc-show",
    attrs: {
      "src": require("../../../../static/img/promotion/top_bg_app.png"),
      "alt": "bg-top"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left-org"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-blu-circle"
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "right-blu"
  }), _vm._v(" "), _c('img', {
    staticClass: "bg-bottom",
    attrs: {
      "src": require("../../../../static/img/promotion/bg-bottom.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "platform-h5 phone-show"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../../static/img/promotion/download.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/steps_app1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }, [_c('span'), _c('span'), _c('span')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/steps_app2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }, [_c('span'), _c('span'), _c('span')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/steps_app3.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ba884d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/promotion/lp/App.vue
// module id = 1319
// module chunks = 1